/**
 * This is the starting point of your application.
 * Feature Hub Apps will use this file to bootstrap the app.
 */
import React from 'react';
import type { AudiFooterProps } from './components/footer/audi-footer';
import AudiFooter from './components/footer/audi-footer';

const FeatureApp: React.FC<AudiFooterProps> = ({
  localeService,
  countryCode,
  featureAppId,
  referenceServiceManager,
  layerManager,
}) => {
  return (
    <AudiFooter
      localeService={localeService}
      countryCode={countryCode}
      featureAppId={featureAppId}
      referenceServiceManager={referenceServiceManager}
      layerManager={layerManager}
    />
  );
};

export default FeatureApp;
